<template lang="html">
  <section class="TokNavBar">
    <div v-if="!isHome" class="TokNavBar__left" @click="back()">
      <BackGlyph></BackGlyph>
    </div>
    <div class="TokNavBar__center" :class="{ noLeftButton: isHome }">
      <div class="TokNavBar__center__text">
        <div class="TokNavBar__center__text__logo">
          <img v-if="getNavTitle === ''" :src="`${conf[env].assetsUrl}img/${logo}`" :alt="getNavTitle">
        </div>
        <div class="TokNavBar__center__text__title">
          {{ getNavTitle }}
        </div>
      </div>
    </div>
    <div class="TokNavBar__right">
      <PaywallGlyph v-if="me && me.registered && !isPaywall"
                    @click.native="$router.push('payWall')"/>
      <MyMenu></MyMenu>
    </div>
  </section>
</template>

<script lang="js">
// import SearchGlyph from '@/components/glyphs/SearchGlyph.vue';
import { mapMutations, mapGetters, mapState } from 'vuex';
import PaywallGlyph from '@/components/glyphs/PaywallGlyph.vue';
import BackGlyph from '@/components/glyphs/BackGlyph.vue';
import MyMenu from '@/components/MyMenu.vue';

export default {
  name: 'nav-bar',
  props: ['title'],
  computed: {
    ...mapState(['me', 'anim']),
    ...mapGetters(['getNavTitle']),
    isHome() {
      return this.$route.path === '/';
    },
    isPaywall() {
      return this.$router.currentRoute.name === 'PayWall';
    },
  },
  components: {
    BackGlyph,
    PaywallGlyph,
    MyMenu,
  },
  methods: {
    ...mapMutations([
      'appReady',
      'displayPaywall',
      'reverseAnimation',
    ]),
    back() {
      this.reverseAnimation();
      this.appReady(false);
      this.$router.push('/');
    },
  },
};
</script>
<style lang="scss" scoped>
.TokNavBar {
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  box-shadow: 0 0 60px 20px rgba(255,255,255, 0.1);
}
</style>
